export default {
  orders: [],
  orders_total: 0,
}